import React from 'react';
import './AutoCompleteSuggestions.scss';

interface AutoCompleteSuggestionsProps {
  onSelection: (suggestion: string) => void;
  suggestions: string[];
  selectedSuggestion: number;
  autocompleteFrom: string;
}

export const AutoCompleteSuggestions = ({
  suggestions,
  onSelection,
  selectedSuggestion,
  autocompleteFrom,
}: AutoCompleteSuggestionsProps) => {
  return (
    <div className='c-search-autocomplete'>
      <hr />
      <ul className='ac_results m-search-bar-suggestions'>
        {suggestions.map((suggestion, index) => (
          <li
            key={index}
            className={index === selectedSuggestion ? 'selected' : ''}
            onClick={() => onSelection(suggestion)}
          >
            <span>
              <span className='strong'>{autocompleteFrom}</span>
              {suggestion.substr(autocompleteFrom.length)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
